<template>
    <psi-dialog
        headingColor="primary"
        icon="mdi-scale-balance"
        :title="`Case Details`"
        hide-actions
        @close="$emit('close')"
    >
        <v-row class="justify-center">
            <v-col cols="12">
                <!-- Case Details Header -->
                <case-detail-header
                    :case-details="caseDetails"
                ></case-detail-header>
                <!-- CaseDetails Profile -->
                <case-detail-profile
                    class="my-3"
                    :case-details="caseDetails"
                ></case-detail-profile>
                <!-- Case DetailsInfo -->
                <case-detail-info
                    class="mt-6"
                    :case-details="caseDetails"
                ></case-detail-info>
                <!-- Case Details Events -->
                <case-detail-events
                    class="mt-6"
                    :case-details="caseDetails"
                    v-if="$_.get(caseDetails, 'case.events', []).length > 0"
                >
                </case-detail-events>
                <!-- Case Details Charges -->
                <case-detail-charges
                    class="mt-6"
                    :case-details="caseDetails"
                ></case-detail-charges>
            </v-col>
        </v-row>
    </psi-dialog>
</template>
<script>
export default {
    name: "screen-ojin-case-details",
    components: {
        CaseDetailHeader: () => import("./CaseDetailHeader"),
        CaseDetailProfile: () => import("./CaseDetailProfile"),
        CaseDetailInfo: () => import("./CaseDetailInfo"),
        CaseDetailEvents: () => import("./CaseDetailEvents"),
        CaseDetailCharges: () => import("./CaseDetailCharges"),
    },
    props: {
        caseDetails: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    updated() {},
    detroyed() {},
    methods: {},
};
</script>

<style scoped>
</style>